// candidate-commit-restore-base-entries.ts
//
// Split out of candidate-commit-without-controller-paths.ts (code review P3
// L1: that file sat at 199 lines). Plumbing shared by the candidate builder:
// a git call that throws on failure, and putting the BASE's entries of the
// stripped controller-owned paths back into the temporary index (CXR-04).
import type { GitRunner } from "./commit-owner-git-ops.js";

export async function gitOrThrow(
  gitRunner: GitRunner,
  args: string[],
  cwd: string,
  env?: Record<string, string>,
): Promise<string> {
  const res = await gitRunner(args, cwd, env ? { env } : undefined);
  if (res.status !== 0) {
    throw new Error(
      `candidate-commit: git ${args.join(" ")} thất bại (status ${res.status}): ${res.stderr}`,
    );
  }
  return res.stdout.trim();
}

/**
 * Codex review CXR-04 (2026-10-01): stripping a controller-owned path whole
 * also dropped what the BASE tracked there (a brownfield repo's own
 * `.claude/settings.json`) — the MR deleted files no ticket touched. Put the
 * base's entries back byte for byte; the controller's additions/edits stay out.
 */
export async function restoreBaseEntriesOfStrippedPaths(
  input: { gitRunner: GitRunner; repoDir: string; baseSha: string },
  stripped: readonly string[],
  env: Record<string, string>,
): Promise<void> {
  for (const path of stripped) {
    const lsTree = ["ls-tree", input.baseSha, "--", path];
    const entry = await gitOrThrow(input.gitRunner, lsTree, input.repoDir);
    // "<mode> <type> <sha>\t<path>" — empty when the base does not track it.
    const match = /^(\d+) (\w+) ([0-9a-f]+)\t/.exec(entry);
    if (match === null) continue;
    const [, mode, type, sha] = match;
    const args =
      type === "tree"
        ? ["read-tree", `--prefix=${path}/`, sha as string]
        : ["update-index", "--add", "--cacheinfo", `${mode},${sha},${path}`];
    await gitOrThrow(input.gitRunner, args, input.repoDir, env);
  }
}
